import { render, staticRenderFns } from "./novo.vue?vue&type=template&id=7a25bf2d&"
import script from "./novo.vue?vue&type=script&lang=js&"
export * from "./novo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports